<template>
  <div>
    <div v-if="busy" class="ui segment">
      <div class="ui active inverted dimmer">
        <div class="ui text loader">处理中...</div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: ['busy'],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>

